import React from 'react';
import useMemo from '@/util/hook/useMemo';
import { BUTTON_SIZE } from '@/config/ui/button';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
import { BackButton, ForwardButton } from '../../component/atom/Button';
import Header from '../../component/atom/Header';
import { Check } from '../../component/atom/Icon';
import Label from '../../component/atom/Label';
import RWDPageLayout from '../../component/composite/RWDPageLayout';
import { S } from './style';
import { AGREEMENT_LIST } from '../../config/agreement';
import { APP } from '../../config/app';
import { FORM_FIELD_ERROR_FEEDBACK_TEXT } from '../../config/error';
import { MAX_NOTES_LENGTH } from '../../config/form';
const renderHeader = () => (<Header progress={APP.PAGE_PROGRESS_INFO['/notesAndAgreement'].progress} progressTitle={APP.PAGE_PROGRESS_INFO['/notesAndAgreement'].title}/>);
const renderNotesField = ({ notes, isNotesError, notesTextareaRowCount, notesPlaceholder, handleNotesTextareaChange, }) => (<>
    <S.FieldBox isError={isNotesError}>
      <S.TextArea maxLength={MAX_NOTES_LENGTH} rows={notesTextareaRowCount} value={notes} placeholder={notesPlaceholder} onChange={handleNotesTextareaChange}/>
    </S.FieldBox>
    {isNotesError ? (<S.TextareaFeedbackErrorText>
        {FORM_FIELD_ERROR_FEEDBACK_TEXT.INVALID_LENGTH}
      </S.TextareaFeedbackErrorText>) : null}
  </>);
const renderAgreementField = ({ doAgreePlatformPolicy, handleAgreeCheckboxChange, }) => (<div>
    <S.Description isError={doAgreePlatformPolicy === false}>
      <ul>
        {AGREEMENT_LIST.map((item) => (<li key={item}>{item}</li>))}
      </ul>
    </S.Description>
    <S.LayoutCheckBox htmlFor='confirm'>
      <S.CheckBox>
        {doAgreePlatformPolicy ? <Check color={SEMANTIC_COLORS.PRIMARY_ICON} size='16px'/> : null}
      </S.CheckBox>
      我同意上述規範。
      <S.InputHidden id='confirm' type='checkbox' checked={doAgreePlatformPolicy === true} onChange={handleAgreeCheckboxChange}/>
    </S.LayoutCheckBox>
    <S.FeedbackErrorText isShow={doAgreePlatformPolicy === false}>
      ＊請勾選同意事項。
    </S.FeedbackErrorText>
  </div>);
const renderFooter = ({ handleBackButtonClick, handleForwardButtonClick, }) => (<S.LayoutFooter>
    <BackButton size={BUTTON_SIZE.LARGE} isAvailable onButtonClick={handleBackButtonClick}>
      上一步
    </BackButton>
    <S.GapRow width={40}/>
    <ForwardButton size={BUTTON_SIZE.LARGE} isAvailable onButtonClick={handleForwardButtonClick}>
      下一步
    </ForwardButton>
  </S.LayoutFooter>);
export default function View({ 
// data
isLoading, notes, isNotesError, notesTextareaRowCount, notesPlaceholder, doAgreePlatformPolicy, 
// func
handleNotesTextareaChange, handleAgreeCheckboxChange, handleBackButtonClick, handleForwardButtonClick, }) {
    const header = useMemo(() => renderHeader(), []);
    const notesField = useMemo(() => renderNotesField({
        notes,
        isNotesError,
        notesTextareaRowCount,
        notesPlaceholder,
        handleNotesTextareaChange,
    }), [notes, isNotesError, notesTextareaRowCount, notesPlaceholder, handleNotesTextareaChange]);
    const agreementField = useMemo(() => renderAgreementField({
        doAgreePlatformPolicy,
        handleAgreeCheckboxChange,
    }), [doAgreePlatformPolicy, handleAgreeCheckboxChange]);
    const footer = useMemo(() => renderFooter({
        handleBackButtonClick,
        handleForwardButtonClick,
    }), [handleBackButtonClick, handleForwardButtonClick]);
    return (<RWDPageLayout isLoading={isLoading}>
      {header}
      <S.Layout>
        <S.LayoutInputFields>
          <Label title='給照服員的資訊'/>
          {notesField}
        </S.LayoutInputFields>
        <S.LayoutInputFields isLast>
          <Label title='同意事項'/>
          {agreementField}
        </S.LayoutInputFields>
        {footer}
      </S.Layout>
    </RWDPageLayout>);
}
